import { Component, OnInit } from '@angular/core';
import { Language } from 'src/app/tools/language/language';
import { dataText } from './dataText';

@Component({
  selector: 'app-in-maintenance-page',
  templateUrl: './in-maintenance-page.component.html',
  styleUrls: ['./in-maintenance-page.component.scss']
})
export class InMaintenancePageComponent implements OnInit {

  public lang: any = Language.currentLanguage.lenid;
  public title: string;
  public text: string;
  public totalParticles = Array(20).fill(0).map((x, i) => i);
  
  constructor() { }

  ngOnInit(): void {
    if (this.lang === 'es') {
      this.title = dataText.es.title;
      this.text = dataText.es.text;
    } else if (this.lang === 'en') {
      this.title = dataText.en.title;
      this.text = dataText.en.text;
    } else if (this.lang === 'pt') {
      this.title = dataText.pt.title;
      this.text = dataText.pt.text;
    }
  }

}
